
(function documentCategoryDefinition() {
    'use strict';
    angular.module('Entities')
        .service('documentCategoryService', [
            'restUrlBuilder', function documentCategoryService(restUrlBuilder) {


                this.getById = function getById(id) {
                    return restUrlBuilder.one('documentCategories', id).get();
                };

                this.get = function get(name) {

                    var params = { Name: name };

                    return restUrlBuilder.all('documentCategories')
                        .get({ params: params });

                };

                this.create = function documentCategoryCreate(documentCategory) {
                    if (documentCategory == null)
                        throw "documentCategory no puede ser null";

                    return restUrlBuilder.all('documentCategories')
                      .post(documentCategory);
                };

                this.modify = function documentCategoryModify(documentCategory) {
                    if (documentCategory == null)
                        throw "documentCategory no puede ser null";

                    return restUrlBuilder.all('documentCategories').put(documentCategory);
                };

            }
        ]);

})();